import { CommunicationBridge } from '@sequelae/lore-mfe-kit';

type HostEnvelope = {
  type: string;
  payload?: Record<string, unknown>;
};

function postEnvelopeToHost(envelope: HostEnvelope) {
  const targets: Window[] = [];

  if (typeof window === 'undefined') {
    return;
  }

  if (window.parent && window.parent !== window) {
    targets.push(window.parent);
  }

  if (window.opener && window.opener !== window) {
    targets.push(window.opener);
  }

  for (const target of targets) {
    try {
      target.postMessage(envelope, '*');
      target.postMessage(JSON.stringify(envelope), '*');
    } catch {
      // Ignore cross-window messaging failures; fallback is best-effort.
    }
  }
}

/**
 * Request host surface close with native bridge first, then web-host envelope
 * fallback for iframe-mounted shells.
 */
export async function requestHostCloseSurface(reason = 'diagnostics-finish-request'): Promise<void> {
  let bridgeAvailable = false;

  try {
    bridgeAvailable = await CommunicationBridge.isAvailable();
  } catch {
    bridgeAvailable = false;
  }

  if (bridgeAvailable) {
    try {
      await CommunicationBridge.onFinished();
      return;
    } catch {
      // Continue to hosted-web fallback envelopes.
    }
  }

  postEnvelopeToHost({
    type: 'MODULE_FINISHED',
    payload: { reason },
  });
  postEnvelopeToHost({
    type: 'NAVIGATION_GOBACK',
    payload: { reason },
  });
}
